export default __webpack_public_path__ + "static/media/events-icon.7f36d5bb.webp";